import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiUrl } from '../shared/models/apiurl.models';
import { Paged } from './seller.service';

/** A person in a followers or blocked list. Same PII rule as the profile. */
export interface FollowPerson {
  id: number;
  display_name: string;
  avatar: string | null;
  is_vip: boolean;
  store: { id: number; name: string; subtitle: string; logo: string | null } | null;
  /** Only present on rows from the blocked list. */
  blocked_at?: string;
}

@Injectable({ providedIn: 'root' })
export class FollowersService {
  constructor(private http: HttpClient, private apiUrl: ApiUrl) {}

  private get authOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: this.apiUrl.getJWTToken(),
      }),
    };
  }

  /**
   * My own followers.
   *
   * Uses the me/ route rather than users/<id>/followers/ because the web app
   * has no record of the logged-in user's id — the caller is resolved
   * server-side, same as me/feed/ and me/blocked/.
   */
  myFollowers(page = 1): Observable<Paged<FollowPerson>> {
    return this.http.get<Paged<FollowPerson>>(
      `${this.apiUrl.getMyFollowersUrl()}?page=${page}`,
      this.authOptions
    );
  }

  blocked(page = 1): Observable<Paged<FollowPerson>> {
    return this.http.get<Paged<FollowPerson>>(
      `${this.apiUrl.getBlockedListUrl()}?page=${page}`,
      this.authOptions
    );
  }

  block(userId: number): Observable<any> {
    return this.http.post(this.apiUrl.getBlockUrl(userId), {}, this.authOptions);
  }

  unblock(userId: number): Observable<any> {
    return this.http.delete(this.apiUrl.getBlockUrl(userId), this.authOptions);
  }
}
